import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { environment } from 'src/environments/environment'

const EXCLUDED_URLS = [`${environment.cognitoDomain}/oauth2/token`]
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  intercept (
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (EXCLUDED_URLS.some(url => request.url.includes(url))) {
      return next.handle(request)
    }
    const token = window.localStorage.getItem('id_token')
    if (token) {
      const clonedRequest = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`)
      })
      return next.handle(clonedRequest)
    }
    return next.handle(request)
  }
}
